import { CurrentUserModel } from '@/__generated';

export interface AppCurrentUserModel extends CurrentUserModel {
  /**  */
  roleClaims?: string[];
}

export enum GLOBAL_APP_ROLE {
  SuperAdmin = 'SuperAdmin',
  GlobalCashier = 'Global Cashier',
  SystemAdministrators = 'SYSTEM ADMINISTRATORS',
  BusinessAnalyst = 'Business Analyst',
  GlobalStationAdministrator = 'Global Station Administrator',
  FinancialController = 'Financial Controller',
  Compliance = 'Compliance',
  GlobalTreasurer = 'Global Treasurer',
  Treasurer = 'Treasurer',
  StationAdministrator = 'Station Administrator',
  CustomerCare = 'Customer Care',
  NetworkMonitor = 'Network Monitor',
}

export enum APP_PERMISSIONS {
  SearchViewTrips = 'Search & View Trips',
  SellTickets = 'Sell Tickets',
  ViewTicketsOnly = 'View Tickets Only',
  ManageTickets = 'Manage Tickets',
  SearchViewShipments = 'Search & View Shipments',
  ViewShipmentBookingsOnly = 'View Shipment Bookings Only',
  SellShipments = 'Sell Shipments',
  ManageShipmentBookings = "Manage Shipment's Bookings",
  CheckIn = 'CheckIn',
  ViewCompanyDashboard = 'View Company Dashboard',
  ViewCompanyReport = 'View Reports',
  ViewTripStatus = 'View Trip Status',
  UpdateTripStatus = 'Update Trip Status',
  ManageBookings = "Manage Ticket's Bookings",
  ViewPassengersOnly = 'View Passengers Only',
  ManagePassenger = 'Manage Passengers',
  ViewConflictTicketsOnly = 'View Conflict Tickets Only',
  ManageConflictTickets = 'Manage Conflict Tickets',
  ManageRegisters = 'Manage Registers',
  ViewNotifications = 'View Notifications',
  ManageTemplates = 'Manage Templates',
  ManageCompanySettings = 'Manage Company Settings',
  ViewDiscountsOnly = 'View Discounts Only',
  ManageDiscounts = 'Manage Discounts',
  ManageSubscriptions = 'Manage Subscriptions',
  ManageAccounts = 'Manage Accounts',
  ViewStationsOnly = 'View Stations Only',
  ManageStations = 'Manage Stations',
  ManageStationBalance = 'Manage Station Balance',
  ManageStationPrinter = 'Manage Station Printers',
  ViewFleetsTripsTariffs = 'View Fleets, Trips & Tariffs Only',
  ManageFleetsTrips = 'Manage Fleets & Trips',
  ManageTicketTariffs = 'Manage Ticket Tariffs',
  ManageBaggageTariffs = 'Manage Baggage Tariffs',
  ManageSellOnTheGoReconciliation = 'Manage Sell On The Go Reconciliation',
  ExportTravelerReport = 'Export Traveler Report',
  ManageBaggageReconciliation = 'Manage Baggage Reconciliation',
  // P43 : avoirs de la compagnie, en lecture seule.
  ViewCreditNotes = 'View Credit Notes',
}

export enum GLOBAL_APP_PERMISSIONS {
  ViewDashboard = 'View Dashboard',
  ViewNotifications = 'View Notifications',

  SearchAndViewTrips = 'Search & View Trips',
  SellTickets = 'Sell Tickets',
  ViewTicketOnly = 'View Tickets Only',
  ManageTickets = 'Manage Tickets',
  SearchAndViewShipments = 'Search & View Shipments',
  ViewShipmentBookingsOnly = 'View Shipment Bookings Only',
  SellShipments = 'Sell Shipments',
  ManageShipmentBookings = "Manage Shipment's Bookings",
  ViewReports = 'View Reports',

  ManageGlobalUsers = 'Manage Global Users',
  ManageAccessControl = 'Manage Access Control',
  ManagePartners = 'Manage Partners',
  ManageCompanies = 'Manage Companies',
  ManagePrismePassengers = 'Manage Prisme Passengers',
  ManageRegisters = 'Manage Registers',
  ManageServices = 'Manage Services',
  ManagePlans = 'Manage Plans',
  ViewStationsOnly = 'View Stations Only',
  ManageStations = 'Manage Stations',
  ManageStationsBalance = 'Manage Station Balance',
  ManageStationPrinters = 'Manage Station Printers',
  ManageGlobalSettings = 'Manage Global Settings',
  ManageSoftwareComponents = 'Manage Software Components',
  ManageGeoMaster = 'Manage Geo Master',
  ManageTemplates = 'Manage Templates',
  ManagePrismeBookings = 'Manage Prisme Bookings',
  ViewDiscountsOnly = 'View Discounts Only',
  ManageDiscounts = 'Manage Discounts',
  ManagePrismeAppSettings = 'Manage Prisme App Settings',
}

export const hasRoles = (roles: string[] | '*' | undefined, auth: AppCurrentUserModel | null) => {
  return roles === '*' || auth?.roles?.some(x => roles?.includes(x));
};

export const hasPermissions = (permissions: string[] | '*' | undefined, auth: AppCurrentUserModel | null) => {
  return permissions === '*' || permissions?.includes('*') || auth?.permissions?.some(x => permissions?.includes(x));
};
